import React, { useEffect, useState } from "react";
// import Banner from "../components/banner";
import useAPI from "../hooks/use-api";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import pfc from "@/utils/pfc";
// import Swiper core and required modules
import SwiperCore, { Pagination, Autoplay } from "swiper";

SwiperCore.use([Pagination, Autoplay]);

const DEFAULT_BANNER = {
  desktop: require("@/assets/img/banner/PC-01.jpg").default,
  mobile: require("@/assets/img/banner/Mobile-01.jpg").default,
};

function Home() {
  const api = useAPI();
  const [partner, setPartner] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [swiperReady, setSwiperReady] = useState(false);
  const [homeBanners, setHomeBanners] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const [partnerJSON, bannerData] = await Promise.all([
        api.getPartner(),
        pfc.fetchPfc('th_homepage_banner_image').catch(() => null),
      ]);
      setPartner(partnerJSON);
      if (bannerData) {
        const pcList = bannerData.pc_banner_images || [];
        const mobileList = bannerData.mobile || [];
        const len = Math.max(pcList.length, mobileList.length);
        setHomeBanners(
          Array.from({ length: len }, (_, i) => ({
            desktop: pcList[i]?.image || DEFAULT_BANNER.desktop,
            mobile: mobileList[i]?.image || DEFAULT_BANNER.mobile,
          }))
        );
      }
      setLoading(false);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
      <div className="banner-placeholder w-full flex items-center justify-center">
        <h1 className="text-2xl p-5 text-center">Loading...</h1>
      </div>
    );
  }

  return (
    <div>
      {/* <div className="hidden md:block relative w-full">
        <div className="absolute banner-text1">
          <p>
            SeaInsure Broker <br />
            ซีอินชัวร์ โบรคเกอร์
          </p>
        </div>
        <div className="absolute banner-text2">
          <p>
            เพียบพร้อมไปด้วยทีมผู้เชี่ยวชาญ <br />
            ด้านการประกันภัย เป็นพันธมิตรกับประกันวินาศภัย
          </p>
        </div>
        <Banner
          className="object-cover"
          src={require("@/assets/img/banner_home.png").default}
          style={{ height: "720px", width: "100%" }}
        />
      </div> */}

      <div className="relative w-full banner-placeholder">
        {(!swiperReady || homeBanners.length === 0) && (
          <div className="w-full">
            <img
              alt="banner"
              src={homeBanners[0]?.desktop || DEFAULT_BANNER.desktop}
              className="hidden md:block w-full h-auto"
            />
            <img
              alt="banner"
              src={homeBanners[0]?.mobile || DEFAULT_BANNER.mobile}
              className="md:hidden w-full h-auto"
            />
          </div>
        )}
        {homeBanners.length > 0 && (
          <div style={swiperReady ? undefined : { position: 'absolute', top: 0, left: 0, width: '100%', opacity: 0 }}>
            <Swiper
              autoplay={{ delay: 4000, disableOnInteraction: false }}
              loop={true}
              pagination={{ clickable: true }}
              className="home-banner-swiper"
              onInit={() => setSwiperReady(true)}
            >
              {homeBanners.map((banner, idx) => (
                <SwiperSlide key={idx}>
                  <img
                    alt="banner"
                    src={banner.desktop}
                    className="hidden md:block w-full h-auto"
                    loading={idx === 0 ? "eager" : "lazy"}
                  />
                  <img
                    alt="banner"
                    src={banner.mobile}
                    className="md:hidden w-full h-auto"
                    loading={idx === 0 ? "eager" : "lazy"}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
      </div>

      <div className="m-auto" style={{ maxWidth: '1260px' }}>
        <img
          alt="logo"
          src={require('@/assets/img/logo.png').default}
          className="m-auto md:mt-20 mt-10 px-10 w-96"
          id="history"
          loading="lazy"
        />

        <div className="m-auto text-left md:text-center py-8 px-5" style={{ fontSize: '16px' }}>
          <p>
            โมนี่อินชัวร์ โบรคเกอร์ เป็นส่วนหนึ่งของ Sea Group บริษัทชั้นนำระดับโลกด้านการให้บริการอินเทอร์เน็ตแพลตฟอร์มสำหรับผู้บริโภค
          </p>
          <br />
          <p className="hidden md:block">
            โมนี่อินชัวร์ โบรคเกอร์ เพียบพร้อมไปด้วยทีมผู้เชี่ยวชาญด้านการประกันภัย เรามุ่งมั่นที่จะช่วยเหลือลูกค้าในการจัดการความเสี่ยงภัยทางธุรกิจ โมนี่อินชัวร์ โบรคเกอร์
          </p>
          <p className="md:hidden">
            โมนี่อินชัวร์ โบรคเกอร์ เพียบพร้อมไปด้วยทีมผู้เชี่ยวชาญด้านการประกันภัย เรามุ่งมั่นที่จะช่วยเหลือลูกค้าในการจัดการความเสี่ยงภัยทางธุรกิจ โมนี่อินชัวร์ โบรคเกอร์
          </p>
          <p>
            ให้บริการผลิตภัณฑ์ประกันชีวิตและวินาศภัยที่หลากหลายครอบคลุมทุกความเสี่ยงภัย และเป็นพันธมิตรกับบริษัทประกันชั้นนำในประเทศไทย

          </p>
        </div>
        <div className="hidden md:block m-auto text-center py-4 px-5 md:py-8">
          <h1>ทำไมต้องเลือก โมนี่อินชัวร์ โบรคเกอร์? </h1>
        </div>
        <div className="md:hidden m-auto text-center py-4 px-5 md:py-8">
          <h1>
            ทำไมต้องเลือก <br /> โมนี่อินชัวร์ โบรคเกอร์?
          </h1>
        </div>
        <div className="why-container gap-6 px-5">
          <div className="why-box flex-col p-6 ">
            <img
              alt="grow"
              loading="lazy"
              src={require('@/assets/img/icon/icon_grow.png').default}
            />
            <p className="text-center">มีพันธมิตรและเครือข่ายมากมาย</p>
            <p className="text-center">ที่พร้อมสนับสนุนธุรกิจให้ก้าวไกล</p>
          </div>
          <div className="why-box flex-col p-6">
            <img
              alt="product"
              loading="lazy"
              src={require('@/assets/img/icon/icon_product.png').default}
            />
            <p className="text-center">มีผลิตภัณฑ์ประกันภัยให้เลือกมากมาย</p>
            <p className="text-center">ครอบคลุมหลายโจทย์ธุรกิจ</p>
          </div>
          <div className="why-box flex-col p-6">
            <img
              alt="protext"
              loading="lazy"
              src={require('@/assets/img/icon/icon_chat.png').default}
            />
            <p className="text-center">มีพนักงานผู้เชี่ยวชาญ</p>
            <p className="text-center">พร้อมให้บริการและคำปรึกษา</p>
          </div>
          <div className="why-box flex-col p-6">
            <img
              alt="grow"
              loading="lazy"
              src={require('@/assets/img/icon/icon_protect.png').default}
            />
            <p className="text-center">
              ปลอดภัย <br />
              ได้รับใบอนุญาตจากสำนักงาน
              <br />
              คณะกรรมการกำกับและส่งเสริมการประกอบธุรกิจ ประกันภัย (คปภ.)
            </p>
          </div>
        </div>
        <div className="m-auto text-center pt-20 pb-8" id="partner">
          <h1>บริษัทพันธมิตรชั้นนำ</h1>
        </div>
        <div className="py-6 px-5">
          <Swiper
            pagination={{
              bulletActiveClass: 'button-swiper-active',
              bulletClass: 'button-swiper',
              el: '.my-custom-pagination-div',
              clickable: true,
            }}
            // pagination={true}
            className="mySwiper"
          >
            <SwiperSlide>
              <div className="partner-container gap-6">
                {partner.map(title => {
                  const imgSrc = require(`@/assets/img/partner/${title.title}.png`).default

                  return (
                    <div className="partner-box flex items-center" key={title.title}>
                      <img
                        alt="partner"
                        className="m-auto object-contain p-3"
                        style={{ maxHeight: '100px' }}
                        loading="lazy"
                        src={imgSrc}
                      />
                    </div>
                  )
                })}
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  )
}

export default Home;
